import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiResponseModel, ApiVisa } from '../../shared';
import { MrpJobTemplateToProcessTemplateLinkContainerModel } from '../../../../../../models/aggregates/mrp-process';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MultiJobTemplateToProcessTemplateLinkService extends BaseApiTemplateService<MrpJobTemplateToProcessTemplateLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-job-template-to-process-template-link"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-job-template-to-process-template-link"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-job-template-to-process-template-link"
    this.httpClient = http;
  }

  postMulti(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + '/multi/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}
